import type { TMessages } from '@/types/TMessages'

export const messages = {
  title: 'Выберите предпочтительный способ связи',
} as const satisfies TMessages
